import React, { useState } from "react";
// Side cards ("Don't take our word for it." / "Still have questions?") are
// hidden for now — kept here so they can be dropped back in.
// import FaqSideCards from "./FaqSideCards";

const HEADING = { top: "Frequently Asked", bottom: "Questions." };

const SUBHEADING =
  "Get in touch if anything is left unanswered — we'll help you join our community of Founders, Investors & KOLs.";

const QUESTIONS = [
  {
    q: "Are there any paid subscriptions to join The Crypto Hub?",
    a: "Currently there are no paid subscriptions and you can enjoy all benefits free of cost. As and when there be any premium features, all registered members will be informed accordingly.",
  },
  {
    q: "How do I join The Crypto Hub?",
    a: "The best way to join TCH is by registering on our website, subscribing to our socials and community groups on Whatsapp & Telegram.",
  },
  {
    q: "How can I be interviewed for the podcast?",
    a: "Usually we invite selected speakers to join our investor, founder & KOL interviews. You may contact us if you want to participate in our interviews or podcasts.",
  },
  {
    q: "How can I be an investor with The Crypto Hub?",
    a: "Please register as an investor by filling in the investor form and we will get in touch with you to understand your investment requirements to find the best deal-flows for you.",
  },
  {
    q: "How can I join TCH cohorts as a founder?",
    a: "Please apply by using the form to send details of your start-up and we will contact you for the next steps to access our suite of services for founders and a chance to list your project on our platform.",
  },
  {
    q: "Who can be a TCH Ambassador, Mentor or KOL?",
    a: "If you are an industry expert in the Blockchain & Web3 space and have an interest in being part of our ecosystem and grow together, we would love to hear from you. Just submit your details online.",
  },
  {
    q: "Do you also invest in Web3 start-ups?",
    a: "We are currently focussing on connecting selected start-ups with investors and we will also be investing in some of the projects in the future.",
  },
];

// Hand-rolled instead of react-bootstrap's Accordion: bootstrap's stylesheet
// loads after Tailwind and would repaint the rows light.
const FaqRow = ({ item, isOpen, onToggle }) => (
  <div className="border-b !border-black/10">
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={isOpen}
      className="w-full bg-transparent border-0 px-0 py-4 flex items-start !justify-between !flex-nowrap gap-6 text-left cursor-pointer group"
    >
      <span
        className={`font-headline font-semibold text-[17px] md:text-lg leading-snug transition-colors duration-200 ${
          isOpen ? "text-accent-on-light" : "text-[#111113] group-hover:text-accent-on-light"
        }`}
      >
        {item.q}
      </span>

      <span
        className={`material-symbols-outlined text-[18px] shrink-0 transition-all duration-300 ${
          isOpen ? "text-accent-on-light rotate-180" : "text-[#4a4753]"
        }`}
      >
        {isOpen ? "remove" : "add"}
      </span>
    </button>

    {/* Grid-rows trick animates height without measuring the body. */}
    <div
      className={`grid transition-all duration-300 ease-out ${
        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
      }`}
    >
      <div className="overflow-hidden">
        <p className="font-body text-sm leading-relaxed text-[#4a4753] pr-10 pb-5 m-0">
          {item.a}
        </p>
      </div>
    </div>
  </div>
);

const FAQ = () => {
  // -1 = every row collapsed on first paint.
  const [openIndex, setOpenIndex] = useState(-1);

  return (
    <section id="mainFaq" className="w-full bg-[#F3F3F3]">
      <div className="max-w-6xl mx-auto px-4 md:px-10 py-12 md:py-16">
        {/* Heading block matches the Mentors & Ambassadors section: same
            container width, centred, same type scale. */}
        <div className="text-center">
          <h2 className="font-headline font-bold text-[#111113] tracking-tight text-[clamp(1.75rem,3.4vw,2.5rem)] leading-[1.12] m-0">
            {HEADING.top}{" "}
            {HEADING.bottom}
          </h2>

          <p className="font-headline text-[#4a4753] text-base md:text-lg leading-relaxed max-w-2xl mx-auto mt-4 mb-0">
            {SUBHEADING}
          </p>
        </div>

        <div className="max-w-3xl mx-auto mt-14">
          {QUESTIONS.map((item, index) => (
            <FaqRow
              key={item.q}
              item={item}
              isOpen={openIndex === index}
              onToggle={() =>
                setOpenIndex(openIndex === index ? -1 : index)
              }
            />
          ))}

          {/* <FaqSideCards /> */}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
